import DeleteIcon from '@mui/icons-material/Delete';
import { Backdrop } from '@mui/material';
import React, { useState } from 'react';

import Arranger from '../base/arranger';
import Button from '../base/button';
import Modal from '../base/modal';
import { ProjectData } from '../dashboard/compliance';

import Spacer, { spc } from '~c/components/base/spacer';
import Text from '~c/components/base/text';

interface ModalContentProps {
  className?: string;
  entry: unknown;
  archiveProjectHandler: (id: string) => void;
  archiveProjectLoading: boolean;
  confirmText?: string;
}

const ModalComponent: React.FC<ModalContentProps> = ({
  className,
  archiveProjectHandler,
  entry,
  archiveProjectLoading,
  confirmText,
}) => {
  const [open, setOpen] = useState<string | null>(null);
  const isProjectData = (data: unknown): data is ProjectData => {
    return (
      typeof data === 'object' &&
      data !== null &&
      'id' in data && // Check for specific properties
      'projectName' in data
    );
  };

  // narrow down the type
  const projectEntry = isProjectData(entry) ? entry : null;

  // Default text if no custom text is provided
  const defaultText = `Are you sure you want to delete project '${projectEntry?.projectName}'?`;
  const displayText = confirmText ?? defaultText;

  return (
    <div
      className={className}
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <Button
        onClick={() => {
          setOpen(projectEntry?.id ?? '');
        }}
        color="error"
        size="large"
        icon={DeleteIcon}
        loading={false}
        disabled={archiveProjectLoading}
      />
      <Modal
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: 'rgba(186, 187, 191, 0.4)',
            },
          },
        }}
        open={open === projectEntry?.id}
        onClose={() => {
          setOpen(null);
        }}
      >
        <Arranger className={className} direction="column" justify="flex-start">
          <Text sz="bold-body16" textAlign="center">
            {displayText}
          </Text>
          <Spacer pb={spc.between_vertical_l} />

          <Arranger
            direction="row"
            justify="center"
            style={{ display: 'flex', gap: '10px' }}
          >
            <Button
              outlined
              onClick={() => {
                setOpen(null);
              }}
            >
              No
            </Button>
            <Button
              color="success"
              loading={archiveProjectLoading}
              disabled={archiveProjectLoading}
              onClick={() => {
                archiveProjectHandler(projectEntry?.id ?? '');
                setOpen(null);
              }}
            >
              Yes
            </Button>
            <Spacer pb={spc.between_horizontal_s} />
          </Arranger>
          <Spacer pb={spc.container_padding_l} />
        </Arranger>
      </Modal>
    </div>
  );
};

export default ModalComponent;
